<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <mat-toolbar class="h-9">
      <button mat-flat-button color="primary" (click)="doExecute()">執行</button>
      <button mat-flat-button color="primary" (click)="doUpdateAll()">更新上市櫃全部</button>
      <button mat-flat-button color="primary" (click)="stkmnUpdateAll()">股票資料更新日期</button>
      <button mat-flat-button color="primary" (click)="test()">開窗測試</button>
    </mat-toolbar>
    <div class="jk-grid-cols-3">

      <div>
        <app-jkdaterange #stklg001 label="日期範圍" [(valueA)]="dateA" [(valueB)]="dateB">
        </app-jkdaterange>
      </div>
      <app-jkbtnedit #stkme001 label="群組" maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002"
        [(value)]="group"></app-jkbtnedit>
      <app-jkmultiselect #stkmj002 maintable="STKMJ" item="W01" label="條件代號" valueExpr="MJ002" displayExpr="MJ003"
        [(values)]="mj002List">
      </app-jkmultiselect>
      <app-jkcombobox label="明細UI模式" [(value)]="uiMode" [items]="uiModeList"></app-jkcombobox>
      <app-jktextarea #stklg001 label="log message" [(value)]="logMessage"></app-jktextarea>
    </div>


  </mat-tab>
</mat-tab-group>
